import React from "react"
import IconButton from '@material-ui/core/IconButton'

import { useCircle } from "./circle.selectors"
import { Link as RouterLink } from "react-router-dom"
import { circleUrl } from "./places"
import { IoIosArrowDropup } from "react-icons/io"

export const ParentCircleIcon = () => {
    const circle = useCircle()

    const ancestry = circle?.ancestry
    if (!ancestry?.length) {
        return null
    }
    const to = circleUrl(ancestry[ancestry.length - 1])
    return (
        <IconButton aria-label="circle parent" color="inherit" component={RouterLink} to={to}>
            <IoIosArrowDropup />
        </IconButton>
    )
}
